<template>
    <div class="left-box">
        <title1 title="运营指标" subTitle="Operation Index" />
        <div class="flex flex-wrap">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex align-center justify-center target2 target2-1 mt-50 width-50">
                <img class="img" :src="require('@/assets/images/exposition/chd-bg-4.png')" alt="">
                <div>
                    <div class="label">{{ item.label }}</div>
                    <div class="num flex justify-center mt-30">{{ item.number }}</div>
                </div>
            </div>
        </div>

        <title1 class="mt-60" type="2" title="日均站点负荷率" />
        <div class="box-1 mt-30">
            <myEchart
                v-if="zhandianfuheShow"
                :id="'zhandianfuhe'"
                :options="zhandianfuheOptions" />
        </div>

        <title1 class="mt-30" title="用户指标" subTitle="User Index" />
        <div class="flex justify-between mt-30">
            <div
                v-for="(item, i) in target2"
                :key="'target1' + i"
                class="flex flex1 flex-direction align-center target1 mt-30">
                <span class="label2">{{ item.label }}</span>
                <div style="position: relative;">
                    <span class="label1">{{ item.number }}</span>
                    <img class="img1 mt-10" :src="require('@/assets/images/exposition/chd-bg-2.png')" alt="">
                </div>
            </div>
        </div>

        <title1 class="mt-40" type="2" title="用户活跃趋势" />
        <div class="box-1 mt-30">
            <myEchart
                v-if="yonghuhuoyueShow"
                :id="'yonghuhuoyue'"
                :options="yonghuhuoyueOptions" />
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from '@/api/dataInterfaceApi'
import myEchart from './../charts/echarts'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        return {
            target1: [
                {
                    number: '100%',
                    label: '本月换电里程(km)'
                },
                {
                    number: '100%',
                    label: '本月充值收入(元)'
                },
                {
                    number: '100%',
                    label: '本月充换电次数'
                },
                {
                    number: '100%',
                    label: '本月充换电电量(kwh)'
                },
            ],
            target2: [
                {
                    number: '',
                    label: '累计入网用户数'
                },
                {
                    number: '',
                    label: '本月新增用户数'
                },
                {
                    number: '',
                    label: '本月活跃用户数'
                },
            ],
            zhandianfuheShow: false,
            zhandianfuheOptions: {},

            yonghuhuoyueShow: false,
            yonghuhuoyueOptions: {}
        }
    },
    methods: {
		getData(data) {
            console.log('snec充换电首页center-1')
            // 考核指标1
            this.yunyingzhibiao(data)
            // 日均站点负荷率
            this.rijunzhandianfuhe(data)
            // 用户指标
            this.yonghuzhibiao1(data)
            this.yonghuzhibiao2(data)
            // 用户活跃趋势
            this.yonghuhuoyuequshi(data)
        },
        // 考核指标1
        yunyingzhibiao(data) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yunyingzhibiao' : 'TiDB-shengshiqu-yunyingzhibiao',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target1[0].number = data.batteryMileage
                this.target1[1].number = data.amount
                this.target1[2].number = data.powerExchangeNum
                this.target1[3].number = data.F_TotalElect
			})
			.catch((err) => {
				console.log(err)
			})
        }, 
        
        // 日均站点负荷率
        rijunzhandianfuhe(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-zhandianrijunfuhelv' : 'TiDB-shengshiqu-zhandianfuhelv',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                // let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push((parseFloat(item.DayStationLod || 0) * 100).toFixed(0))
                    // yData2.push(item.pass_num)
                })
                this.zhandianfuheShow = false
                this.zhandianfuheOptions = {
                    title: {
                        text: '%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '商用车',
                            type: 'bar',
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: 'rgba(10, 225, 183, 0)'
									},
									{
										offset: 1,
										color: 'rgba(15, 255, 208, 1)'
									}])
							},
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' %';
                                }
                            },
                            data: yData1
                        },
                        // {
                        //     name: '乘用车',
                        //     type: 'bar',
                        //     data: yData2
                        // }
                    ]
                }
                this.zhandianfuheShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},

        // 用户指标
        yonghuzhibiao1(data) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yonghuzhibiao' : 'TiDB-shengshiqu-yonghuzhibiao',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target2[0].number = data.AccessUser
			})
			.catch((err) => {
				console.log(err)
			})
        }, 
        yonghuzhibiao2(data) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-benyueyonghu' : 'TiDB-shengshiqu-benyueyonghu',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target2[1].number = data.NewUser
                this.target2[2].number = data.MonthlyActiveUsers
			})
			.catch((err) => {
				console.log(err)
			})
        },
        
        // 用户活跃趋势
        yonghuhuoyuequshi(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yonghuxinzenghuoyuetu' : 'TiDB-shengshiqu-yonghuxinzenghuoyuetu',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push(item.MonthlyActiveUsers)
                    yData2.push(item.NewUsers)
                })
                this.yonghuhuoyueShow = false
                this.yonghuhuoyueOptions = {
                    title: {
                        text: '     人'
                    },
                    color: ['#8bcfd0', '#f2bd4c'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '新增用户',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#8bcfd0'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 次';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData2
                        },
                        {
                            name: '活跃用户',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#f2bd4c'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235, 190, 77, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235, 190, 76, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 次';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                    ]
                }
                this.yonghuhuoyueShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>